var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"rbox"},[_c('head-text',{attrs:{"kpi":_vm.activeKpi,"isSmall":true,"fallbackText":"Process Excellence"}}),_vm._v(" "),_c('item',{attrs:{"thresholdData":_vm.threshold,"round":true,"isSmall":true,"kpi":_vm.activeKpi}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }